import api from "./client"
import type { Client } from "../types"

export async function getClients(): Promise<Client[]> {
  const { data } = await api.get<Client[]>("/clients")
  return data
}

// Alta completa: usuario + membresía + PRIMER PAGO en una sola transacción del
// backend (Clients::Register). Si se registra como cliente nuevo es porque ya
// pagó, y ese pago es lo que fija el vencimiento (hoy + 1 mes) y lo que hace
// que el ingreso exista en Financiero. Con precio 0 (plan "regular") no se crea
// pago y payment_method puede omitirse.
export async function registerClient(params: {
  name: string
  email: string
  password: string
  client_type: string
  plan: string
  price: number
  payment_method?: string
}): Promise<Client> {
  const { data } = await api.post<Client>("/clients", { client: params })
  return data
}

export async function updateClient(
  id: number,
  params: { name?: string; email?: string; client_type?: string },
): Promise<Client> {
  const { data } = await api.patch<Client>(`/clients/${id}`, { user: params })
  return data
}

export async function deleteClient(id: number): Promise<void> {
  await api.delete(`/clients/${id}`)
}

export async function createTrainer(params: {
  name: string
  email: string
  password: string
}): Promise<Client> {
  const { data } = await api.post<{ user: Client }>(
    "/users/sign_up",
    {
      user: { ...params, role: "trainer" },
    },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    },
  )
  return data.user
}
